async function getUsers({ condition, page = 1 }) {
  try {
    const res = await window.window.axios.get(`/api/v1/admin/users/${page}`, { params: condition });
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function updateUser(params) {
  try {
    const res = await window.axios.put('/api/v1/admin/users/detail', params);
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function deleteUser({ _id }) {
  try {
    const res = await window.axios.delete('/api/v1/admin/users', { _id });
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function getUser(id) {
  try {
    const res = await window.axios.get('/api/v1/admin/users/detail', { params: { _id: id } });
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function sendNotif({ id, title, body }) {
  try {
    const res = await window.axios.post('/api/v1/admin/users/notif', { id, title, body });
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function sendMultyNotif({ query, title, body }) {
  try {
    const res = await window.axios.post('/api/v1/admin/users/mnotif', { title, body }, { params: query });
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function changeStatus(id) {
  const resData = await window.axios.post('/api/v1/admin/users/status', { userId: id });
  return resData.data;
}
async function sendMessage(params) {
  const resData = await window.axios.post('/api/v1/admin/users/message', params);
  return resData.data;
}

async function editMessage(params) {
  const resData = await window.axios.put('/api/v1/admin/users/message', params);
  return resData.data;
}

async function deleteMessage(id) {
  const resData = await window.axios.delete('/api/v1/admin/users/message', { params: { id } });
  return resData.data;
}

async function changePass(params) {
  const resData = await window.axios.post('/api/v1/admin/users/pass', params);
  return resData.data;
}

async function exportUserNumbersExcel({ condition = {} }) {
  const resData = await window.axios.get('/api/v1/admin/users/numbers/excel', {
    params: condition,
    responseType: 'blob',
  });
  return resData.data;
}

module.exports = {
  getUsers,
  updateUser,
  deleteUser,
  getUser,
  sendNotif,
  sendMultyNotif,
  changeStatus,
  sendMessage,
  changePass,
  editMessage,
  deleteMessage,
  exportUserNumbersExcel,
};
